export const statusMap = {
  pending: { label: 'Não respondido', color: 'orange' },
  answered: { label: 'Em andamento', color: 'blue' },
  closed: { label: 'Concluído', color: 'green' }
};
